import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { BackLink } from '../components/ui';

const SECTIONS = [
  'goal',
  'tiles',
  'languages',
  'points',
  'contracts',
  'speed',
  'modes',
  'fairness',
  'robots',
] as const;

export function Rules() {
  const { t } = useTranslation();
  return (
    <main className="page rules">
      <BackLink />
      <h1>{t('rules.title')}</h1>
      {SECTIONS.map((s) => (
        <section key={s} className="card">
          <h2>{t(`rules.${s}.title`)}</h2>
          {(t(`rules.${s}.body`, { returnObjects: true }) as string[]).map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </section>
      ))}
      <section className="card">
        <h2>{t('rules.keyboard.title')}</h2>
        <p>{t('rules.keyboard.body')}</p>
      </section>
    </main>
  );
}

export function About() {
  const { t } = useTranslation();
  return (
    <main className="page about">
      <BackLink />
      <h1>{t('about.title')}</h1>
      <p>{t('about.disclaimer')}</p>
      <h2>{t('about.dictionaries')}</h2>
      <ul>
        <li>Français — Dictionnaires orthographiques Grammalecte 7.5 (MPL-2.0)</li>
        <li>English — SCOWL-derived en_US / en_GB Hunspell dictionaries (MIT/BSD)</li>
        <li>Español — RLA-ES es_ES (GPL-3.0 / LGPL-3.0 / MPL-1.1)</li>
        <li>Deutsch — igerman98 (GPL-2.0/3.0) + german-nouns / Wiktionary (CC BY-SA 4.0)</li>
        <li>Italiano — Italian Writing Aids 5.0 (GPL-3.0)</li>
        <li>
          Português — VERO pt_BR (LGPL-3.0 / MPL-2.0) + Natura pt_PT (GPL-2.0 / LGPL-2.1 / MPL-1.1)
        </li>
        <li>{t('about.frequencies')} — wordfreq 3.1.1 (CC BY-SA 4.0)</li>
        <li>
          {t('about.policy')} — LDNOOBW (CC BY 4.0), {t('about.adapted')}
        </li>
      </ul>
      <p className="muted small">{t('about.noticeFiles')}</p>
      <p className="muted small">{t('about.noDefinitions')}</p>
      <nav className="home-links">
        <Link href="/legal/privacy">{t('legal.privacy')}</Link>
        <Link href="/legal/terms">{t('legal.terms')}</Link>
        <Link href="/legal/notice">{t('legal.notice')}</Link>
        <Link href="/legal/delete-account">{t('account.delete')}</Link>
      </nav>
    </main>
  );
}
